// Only the existing-project editor is enabled by the production adapter.
export const PROJECT_IMAGE_MEDIA_WRITES_ENABLED =
  process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE === 'staging' ||
  process.env.NEXT_PUBLIC_BUGSNAG_RELEASE_STAGE === 'production'
